import { Vessel } from '../../../../services/store/modules/vessels/models';

export const getVesselLengthInMeters = (vessel: Vessel): number | undefined => {
  if (vessel.vessel_length == null || vessel.vessel_length === '') {
    return undefined;
  }

  const length = parseFloat(String(vessel.vessel_length));
  if (Number.isNaN(length) || length <= 0) {
    return undefined;
  }

  if (vessel.length_units === 'ft') {
    return length * 0.3048;
  }

  return length;
};

// Formats the length exactly as recorded on the watercraft, in the unit set on
// the record (e.g. "6m" / "20ft"). Distances have no space between the number
// and the unit.
export const formatVesselRecordLength = (vessel: Vessel): string => {
  if (vessel.vessel_length == null || String(vessel.vessel_length) === '') {
    return '';
  }

  return `${vessel.vessel_length}${vessel.length_units ?? ''}`;
};
